import _ from 'lodash';

export default class GooglePlacesHelper {
    static parsePlacesAddress(placesAddress) {
        const address = {
            streetNumber: GooglePlacesHelper.extractAddressComponent(placesAddress, 'street_number', 'long_name'),
            streetName: GooglePlacesHelper.extractAddressComponent(placesAddress, 'route', 'short_name'),
            city: GooglePlacesHelper.extractAddressComponent(placesAddress, 'locality', 'long_name'),
            state: GooglePlacesHelper.extractAddressComponent(
                placesAddress,
                'administrative_area_level_1',
                'short_name'
            ),
            county: GooglePlacesHelper.extractAddressComponent(
                placesAddress,
                'administrative_area_level_2',
                'long_name'
            ),
            zip: GooglePlacesHelper.extractAddressComponent(placesAddress, 'postal_code', 'short_name'),
            direction: null,
            unitNum: null,
        };

        const streetName = address.streetName;
        const streetParts = streetName.split(' ');
        const rawDirection = streetParts[0];
        const possibleStreetSuffix = streetParts[1];
        const direction = GooglePlacesHelper.parseDirection(rawDirection);

        if (direction && !GooglePlacesHelper.isStreetSuffix(possibleStreetSuffix.toLowerCase())) {
            address.streetName = streetName.substr(rawDirection.length + 1);
            address.direction = direction;
        }

        return address;
    }

    static isStreetSuffix(term) {
        switch (term) {
            case 'boulevard':
            case 'blvd':
            case 'court':
            case 'ct':
            case 'drive':
            case 'dr':
            case 'street':
            case 'st':
            case 'road':
            case 'rd':
            case 'way':
            case 'wy':
                return true;
        }

        return false;
    }

    static extractAddressComponent(addressComponents, type, name) {
        const match = _.find(addressComponents, x => {
            return _.includes(x.types.slice(), type);
        });
        return match ? match[name] : null;
    }

    static parseDirection(direction) {
        let x = null;

        switch (direction.toLowerCase()) {
            case 'east':
            case 'e':
                x = 'E';
                break;
            case 'west':
            case 'w':
                x = 'W';
                break;
            case 'north':
            case 'n':
                x = 'N';
                break;
            case 'south':
            case 's':
                x = 'S';
                break;
            case 'northwest':
            case 'nw':
                x = 'NW';
                break;
            case 'northeast':
            case 'ne':
                x = 'NE';
                break;
            case 'southwest':
            case 'sw':
                x = 'SW';
                break;
            case 'southeast':
            case 'se':
                x = 'SE';
                break;
        }

        return x;
    }
}



// WEBPACK FOOTER //
// ./src/utils/google-places-helper.js